/*
 * pb-cta-lead.js — Photobooth360Store
 *
 * POR QUÉ EXISTE (diagnóstico 27/07/2026): de 197 sesiones de pago en 30 días, solo 4
 * llegaron a /pages/contact y NINGUNA envió el formulario. El 96% del tráfico de Ads es
 * móvil. La única vía de contacto visible en móvil era el botón de WhatsApp, que además
 * no estaba medido. Este asset hace dos cosas, ambas ADITIVAS (no modifica el theme):
 *
 *   1. CTA "Solicita Tu Presupuesto" fijo en móvil, en fichas de producto y colecciones,
 *      que lleva al formulario de contacto (el que ya vuelca a Pipedrive).
 *   2. Instrumenta el botón de WhatsApp que ya existía: evento a GA4 al pulsarlo y gclid
 *      dentro del mensaje prellenado, para poder atribuir esos contactos a la campaña.
 *
 * No toca sections/whatsapp-boton.liquid: lo localiza en el DOM y lo enriquece. Para
 * revertirlo basta con quitar la línea del <script> en layout/theme.liquid.
 *
 * Instalación (layout/theme.liquid, antes de </body>):
 *   <script src="{{ 'pb-cta-lead.js' | asset_url }}" data-contact-url="{{ pages.contact.url }}" defer></script>
 */
(function () {
  'use strict';

  var STORE_KEY = 'pb360_attr'; // mismo sessionStorage que usa pipedrive-lead.js

  // Texto por idioma. Title Case y género neutro (reglas de marca).
  var LABELS = {
    es: 'Solicita Tu Presupuesto',
    en: 'Request Your Quote',
    fr: 'Demandez Votre Devis',
    it: 'Richiedi Il Tuo Preventivo',
    pt: 'Solicita O Teu Orçamento',
    de: 'Fordern Sie Ihr Angebot An',
  };

  function lang() {
    var l = (document.documentElement.getAttribute('lang') || 'es').toLowerCase().slice(0, 2);
    return LABELS[l] ? l : 'es';
  }

  function attribution() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  // Envía a GA4 por gtag y/o dataLayer, lo que haya. Nunca rompe si no hay ninguno.
  function track(eventName, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
    } catch (e) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: eventName }, params || {}));
    } catch (e) {}
  }

  // ── 1. Botón de WhatsApp que ya existía: medirlo y arrastrar el gclid ──────────
  // El enlace lo pinta sections/whatsapp-boton.liquid con la clase .wsp-whatsapp.
  //
  // FIDELIDAD DE LA MEDICIÓN (cambio 17-08-2026, decisión del CEO)
  // ──────────────────────────────────────────────────────────────
  // Desde la web es IMPOSIBLE saber si el usuario ENVIÓ el mensaje: al saltar a
  // api.whatsapp.com el navegador entrega el control y no hay callback. Lo máximo
  // observable es que SALIÓ hacia WhatsApp, y eso sí se detecta: cuando la app se abre,
  // la pestaña pierde visibilidad y salta `visibilitychange`. En iOS Safari a veces solo
  // salta `pagehide`, así que se escuchan los dos.
  //
  // Antes se contaba el CLIC. Eso incluye clics accidentales y los que no llegan a abrir
  // nada. Ahora:
  //   · `salida`    → hubo ocultación en los VENTANA_MS siguientes al clic. Solo esta
  //                   dispara el evento de GA4, así que **solo esta llega a Google Ads**.
  //   · `solo_clic` → no hubo ocultación. NO va a GA4, pero sí se registra en el Worker
  //                   para poder medir el abandono.
  //
  // Consecuencia esperada y buscada: el número de `contacto_whatsapp` en Ads BAJA respecto
  // al histórico. No es una regresión, es que antes contaba de más.
  //
  // Las dos van al Worker por `sendBeacon`, que es lo único que sobrevive a que la página
  // se vaya a segundo plano, y además es server-side: ni bloqueadores ni el sandbox de
  // web-pixels de Shopify pueden perderlo.
  var WA_ENDPOINT = 'https://leads.photobooth360store.com/wa-open';
  var VENTANA_MS = 5000;

  function dispositivo() {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent || '') ? 'movil' : 'escritorio';
  }

  function registrarWa(fidelidad, attr) {
    var payload = JSON.stringify({
      fidelidad: fidelidad,
      gclid: attr.gclid || '',
      pagina: window.location.pathname,
      utmSource: attr.attrSource || '',
      utmCampaign: attr.attrCampaign || '',
      idioma: lang(),
      dispositivo: dispositivo(),
    });
    try {
      // text/plain evita el preflight CORS. Mismo truco que pipedrive-lead.js.
      if (navigator.sendBeacon) {
        navigator.sendBeacon(WA_ENDPOINT, new Blob([payload], { type: 'text/plain' }));
        return;
      }
    } catch (e) {}
    try {
      fetch(WA_ENDPOINT, { method: 'POST', body: payload, keepalive: true, mode: 'no-cors' });
    } catch (e) {}
  }

  // OJO (19-08-2026): esto instrumenta TODOS los enlaces de WhatsApp de la página, no
  // el primero. Antes usaba querySelector con una lista de selectores, y una lista
  // devuelve el primer elemento en ORDEN DE DOCUMENTO, no por prioridad del selector.
  // En home, fichas y contacto hay un enlace de WhatsApp incrustado en el contenido por
  // encima del flotante, así que la medición se la quedaba ese y el botón flotante (el
  // que pulsa el 96% del tráfico móvil de Ads) no disparaba nada: ni evento de GA4, ni
  // beacon a /wa-open, ni gclid en el mensaje. El guard dataset.pbTracked evita el doble
  // binding cuando esta función se llama más de una vez.
  function enhanceWhatsapp() {
    var enlaces = document.querySelectorAll(
      'a.wsp-whatsapp, a[href*="api.whatsapp.com/send"], a[href*="wa.me/"]'
    );
    for (var i = 0; i < enlaces.length; i++) instrumentarWhatsapp(enlaces[i]);
  }

  function instrumentarWhatsapp(a) {
    if (!a || a.dataset.pbTracked) return;
    a.dataset.pbTracked = '1';

    var attr = attribution();
    // El gclid viaja dentro del texto del mensaje: es lo único que sobrevive el salto
    // a WhatsApp, y permite reconciliar la conversación con el clic de Ads.
    if (attr.gclid) {
      try {
        var u = new URL(a.href);
        var txt = u.searchParams.get('text') || '';
        if (txt.indexOf('[ref:') === -1) {
          u.searchParams.set('text', txt + ' [ref:' + attr.gclid.slice(0, 40) + ']');
          a.href = u.toString();
        }
      } catch (e) {}
    }

    a.addEventListener('click', function () {
      var attrClic = attribution();
      var resuelto = false;

      function confirmarSalida() {
        if (resuelto || document.visibilityState !== 'hidden') return;
        resuelto = true;
        limpiar();
        // El evento de GA4 SOLO aquí: es lo que llega a Ads como conversión.
        track('contacto_whatsapp', {
          pagina: window.location.pathname,
          origen: attrClic.attrSource || '',
          tiene_gclid: attrClic.gclid ? 'si' : 'no',
          fidelidad: 'salida',
        });
        registrarWa('salida', attrClic);
      }

      function alOcultar() { confirmarSalida(); }
      function alSalir() {
        if (resuelto) return;
        resuelto = true;
        limpiar();
        track('contacto_whatsapp', {
          pagina: window.location.pathname,
          origen: attrClic.attrSource || '',
          tiene_gclid: attrClic.gclid ? 'si' : 'no',
          fidelidad: 'salida',
        });
        registrarWa('salida', attrClic);
      }

      function limpiar() {
        document.removeEventListener('visibilitychange', alOcultar);
        window.removeEventListener('pagehide', alSalir);
        clearTimeout(temporizador);
      }

      // Si en VENTANA_MS la página nunca se ocultó, WhatsApp no llegó a abrirse.
      // Se registra el abandono pero NO se manda a GA4.
      var temporizador = setTimeout(function () {
        if (resuelto) return;
        resuelto = true;
        limpiar();
        registrarWa('solo_clic', attrClic);
      }, VENTANA_MS);

      document.addEventListener('visibilitychange', alOcultar);
      window.addEventListener('pagehide', alSalir);
    });
  }

  // ── 2. CTA de presupuesto en móvil (producto y colección) ─────────────────────
  function shouldShowCta() {
    var p = window.location.pathname;
    return /\/products\//.test(p) || /\/collections\//.test(p);
  }

  function buildCta(contactUrl) {
    if (document.getElementById('pb-cta-lead')) return;

    var css = document.createElement('style');
    // Se queda a la izquierda del botón de WhatsApp (50px + 20px de margen) para no
    // taparlo, y por debajo en z-index. Solo móvil.
    css.textContent =
      '#pb-cta-lead{display:none}' +
      '@media(max-width:768px){' +
      '#pb-cta-lead{display:flex;position:fixed;left:1.6rem;right:8.6rem;bottom:2rem;z-index:99;' +
      'align-items:center;justify-content:center;gap:.8rem;' +
      'min-height:5rem;padding:1.2rem 1.6rem;border-radius:5rem;' +
      'background:#FFB000;color:#0b0b0b;' +
      'font-size:1.5rem;font-weight:600;line-height:1.2;text-align:center;text-decoration:none;' +
      'box-shadow:0 2px 12px rgba(0,0,0,.28)}' +
      '#pb-cta-lead:active{transform:translateY(1px)}' +
      'body{padding-bottom:8rem}' +
      '}';
    document.head.appendChild(css);

    var a = document.createElement('a');
    a.id = 'pb-cta-lead';
    a.href = contactUrl;
    a.textContent = LABELS[lang()];
    a.setAttribute('rel', 'nofollow');
    a.addEventListener('click', function () {
      var attr = attribution();
      track('cta_presupuesto', {
        pagina: window.location.pathname,
        origen: attr.attrSource || '',
        tiene_gclid: attr.gclid ? 'si' : 'no',
      });
    });
    document.body.appendChild(a);
    cedeElPasoAlBotonPrincipal(a);
  }

  // El flotante y el "Añadir al carrito" son dos acciones primarias, y en la ficha de
  // producto se veían a la vez peleándose el mismo pulgar (auditoría de UX 11/08/2026).
  // No se quita ninguno: el flotante se aparta mientras el botón principal está en
  // pantalla y vuelve en cuanto sale de vista, que es cuando de verdad hace falta.
  // Si el navegador no trae IntersectionObserver, se queda como estaba.
  function cedeElPasoAlBotonPrincipal(cta) {
    if (!('IntersectionObserver' in window)) return;
    // El botón vive dentro de <product-form>, que Shopify hidrata después del
    // DOMContentLoaded: al montar el flotante todavía no está en el DOM. Se busca con
    // reintentos cortos y se abandona en silencio si la página no tiene botón (una
    // colección, por ejemplo).
    var intentos = 0;
    (function busca() {
      var principal = document.querySelector(
        'product-form button[name="add"], form[action*="/cart/add"] button[type="submit"]'
      );
      if (!principal) {
        if (++intentos > 20) return;
        return setTimeout(busca, 250);
      }
      engancha(cta, principal);
    })();
  }

  function engancha(cta, principal) {
    cta.style.transition = 'opacity .18s ease, transform .18s ease';
    var obs = new IntersectionObserver(function (entradas) {
      var visible = entradas[0].isIntersecting;
      cta.style.opacity = visible ? '0' : '1';
      cta.style.pointerEvents = visible ? 'none' : 'auto';
      cta.style.transform = visible ? 'translateY(120%)' : 'translateY(0)';
    }, { threshold: 0.35 });
    obs.observe(principal);
  }

  // ── 3. Salidas hacia Snap360 ──────────────────────────────────────────────────
  // El silo de contenido en inglés (apps y software de fotomatón 360) no vende
  // máquinas: quien busca "360 photo booth app" quiere software, no un equipo de
  // varios miles de euros. Su trabajo es llevar gente a Snap360, así que hay que
  // medirlo por eso y no por ventas de la tienda.
  //
  // En los 56 días previos al 01/08/2026 GA4 no registró NI UN clic saliente a
  // snap360app.com (sí 31 a WhatsApp y 3 a fotomaton360eventos.es), pese a que la
  // guía en inglés menciona Snap360 catorce veces. Sin este evento no hay forma de
  // saber si el silo cumple su función.
  //
  // Delegación en document: cubre los enlaces que existan hoy y los que se añadan
  // después sin tener que volver a tocar este fichero.
  function trackSnap360() {
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="snap360"]') : null;
      if (!a) return;
      var attr = attribution();
      track('click_snap360', {
        pagina: window.location.pathname,
        idioma: lang(),
        destino: a.getAttribute('href') || '',
        origen: attr.attrSource || '',
      });
    }, true); // captura: el evento se registra aunque el enlace navegue de inmediato
  }

  // ── 3. Convivencia con el banner de consentimiento ────────────────────────────
  // Medido el 19/08/2026 en movil (390x844): el banner de Shopify ocupa de 663 a 844
  // con z-index 2000000, y el CTA y el WhatsApp viven en 774-824. O sea que en la
  // PRIMERA visita, que es la de todo el trafico de Ads, las dos vias de contacto
  // estan tapadas: un toque encima del WhatsApp se lo lleva el boton "Aceptar".
  // Mientras el banner este visible, los subimos por encima de el.
  //
  // El CTA se mueve con `bottom` y NO con transform a proposito: su animacion de
  // ceder el paso al "Anadir al carrito" ya usa transform, y pisarla lo romperia.
  function ajustarPorConsentimiento() {
    var css = document.createElement('style');
    css.textContent =
      '@media(max-width:768px){' +
      'body.pb-consent-abierto #pb-cta-lead{bottom:calc(2rem + var(--pb-consent-alto,0px))}' +
      'body.pb-consent-abierto a.wsp-whatsapp{opacity:0;visibility:hidden;pointer-events:none}' +
      '}';
    document.head.appendChild(css);

    function medir() {
      var banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
      var visible = false;
      if (banner) {
        var estilo = window.getComputedStyle(banner);
        var caja = banner.getBoundingClientRect();
        visible = estilo.display !== 'none' && estilo.visibility !== 'hidden' && caja.height > 0;
      }
      if (visible) {
        var alto = Math.ceil(banner.getBoundingClientRect().height);
        document.body.style.setProperty('--pb-consent-alto', alto + 'px');
        document.body.classList.add('pb-consent-abierto');
      } else {
        document.body.classList.remove('pb-consent-abierto');
        document.body.style.removeProperty('--pb-consent-alto');
      }
    }

    medir();
    // El banner lo inyecta Shopify despues de cargar la pagina, y desaparece al
    // aceptar o rechazar, asi que hay que mirar el DOM, no solo el arranque.
    try {
      // Atributos SOLO del banner y su contenedor (no de todo el body: Judge.me y los
      // carruseles cambian estilos sin parar y medir() en cada uno costaria hilo).
      var obsBanner = null;
      var alCambiar = function () {
        medir();
        var b = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
        if (b && !obsBanner) {
          var filtro = { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] };
          obsBanner = new MutationObserver(medir);
          obsBanner.observe(b, filtro);
          // Nunca el body: medir() le cambia la clase y se entraria en bucle.
          var padre = b.parentElement;
          if (padre && padre !== document.body && padre !== document.documentElement) {
            obsBanner.observe(padre, filtro);
          }
        }
      };
      new MutationObserver(alCambiar).observe(document.body, { childList: true, subtree: true });
      alCambiar();
    } catch (e) {}
    // FIX-02 (auditoria UX 08/10/2026): al RECHAZAR, Shopify oculta el banner tocando
    // atributos, sin anadir nodos; con solo childList la clase pb-consent-abierto se
    // quedaba puesta y el CTA flotaba a media pantalla sobre el H1.
    document.addEventListener('visitorConsentCollected', function () { setTimeout(medir, 50); });
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      if (t && t.closest && t.closest('#shopify-pc__banner, #shopify-pc__prefs')) {
        setTimeout(medir, 100);
        setTimeout(medir, 600);
        setTimeout(medir, 1500);
      }
    }, true);
    window.addEventListener('resize', medir);
  }

  // ── 4. El WhatsApp cede el paso al boton principal (FIX-03) ──────────────────
  // En el carrito (390x844) el flotante de WhatsApp caia justo encima del extremo
  // derecho de "Pagar pedido", y en la ficha encima de "Anadir al Carrito" segun el
  // scroll. Mismo patron que el CTA de presupuesto: mientras el boton principal esta
  // en pantalla, el WhatsApp se aparta; vuelve en cuanto sale. Solo movil.
  function waCedeAlBotonPrincipal() {
    if (!('IntersectionObserver' in window)) return;
    var css = document.createElement('style');
    css.textContent =
      '@media(max-width:768px){' +
      'body.pb-wa-cede a.wsp-whatsapp{opacity:0;visibility:hidden;pointer-events:none}' +
      '}';
    document.head.appendChild(css);

    var visibles = 0;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var antes = e.target.dataset.pbVisible === '1';
        var ahora = e.isIntersecting;
        if (antes === ahora) return;
        e.target.dataset.pbVisible = ahora ? '1' : '0';
        visibles += ahora ? 1 : -1;
      });
      document.body.classList.toggle('pb-wa-cede', visibles > 0);
    }, { threshold: 0.35 });

    var intentos = 0;
    (function busca() {
      var botones = document.querySelectorAll(
        'main .product__info-container product-form button[name="add"], main #checkout'
      );
      if (!botones.length) {
        if (++intentos > 20) return;
        return setTimeout(busca, 250);
      }
      for (var i = 0; i < botones.length; i++) obs.observe(botones[i]);
    })();
  }

  // ── 5. Presupuesto tambien dentro de la ficha (FIX-04) ────────────────────────
  // En escritorio la ficha no tenia NINGUNA via de presupuesto (el flotante es solo
  // movil) y en movil el flotante se esconde justo cuando "Anadir al Carrito" esta a la
  // vista. Para equipos de 1.900 a 18.000 EUR, que se cierran sobre todo por lead, se
  // pone un enlace secundario (contorno negro, amarillo al pasar) debajo del boton
  // principal, que sigue siendo el negro. Mismo texto y mismo evento de GA4 que el
  // flotante, con `origen_cta: ficha`.
  function ctaEnFicha(contactUrl) {
    if (!/\/products\//.test(window.location.pathname)) return;
    var intentos = 0;
    (function busca() {
      var zona = document.querySelector('main .product__info-container product-form .product-form__buttons');
      if (!zona) {
        if (++intentos > 20) return;
        return setTimeout(busca, 250);
      }
      if (zona.querySelector('.pb-cta-ficha')) return;
      var css = document.createElement('style');
      css.textContent =
        '.pb-cta-ficha{display:flex;align-items:center;justify-content:center;width:100%;' +
        'min-height:4.6rem;margin-top:1rem;padding:1rem 1.6rem;border:2px solid #0b0b0b;' +
        'border-radius:999px;background:#fff;color:#0b0b0b;font-weight:700;' +
        'font-family:var(--font-body-family),sans-serif;' +
        'font-size:1.5rem;line-height:1.2;text-align:center;text-decoration:none}' +
        '.pb-cta-ficha:hover{background:#FFD400}' +
        '.pb-cta-ficha:focus-visible{outline:2px solid #0b0b0b;outline-offset:3px}';
      document.head.appendChild(css);
      var a = document.createElement('a');
      a.className = 'pb-cta-ficha';
      a.href = contactUrl;
      a.rel = 'nofollow';
      a.textContent = LABELS[lang()];
      a.addEventListener('click', function () {
        var attr = attribution();
        track('cta_presupuesto', {
          pagina: window.location.pathname,
          origen: attr.attrSource || '',
          tiene_gclid: attr.gclid ? 'si' : 'no',
          origen_cta: 'ficha',
        });
      });
      zona.appendChild(a);
    })();
  }

  function init() {
    enhanceWhatsapp();
    trackSnap360();
    ajustarPorConsentimiento();
    waCedeAlBotonPrincipal();

    var s = document.currentScript || document.querySelector('script[src*="pb-cta-lead"]');
    var contactUrl = (s && s.getAttribute('data-contact-url')) || '/pages/contact';
    ctaEnFicha(contactUrl);

    if (!shouldShowCta()) return;
    buildCta(contactUrl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
